export function entries<U extends keyof T, T extends { [key: string]: any }>(
    obj: T
): [U, T[U]][] {
    return Object.entries(obj) as [U, T[U]][];
}
